import styled from "styled-components";

export const HeaderDiv = styled.header`
  width: 100%;
  height: var(--headerHeight);
  display: flex;
  padding: var(--outsidePadding);
  background-color: var(--white);
  align-items: center;
  width: 100%;
  font-family: var(--headerFont);
  user-select: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.125);
  & .mobile {
    display: none;
  }
  & h1 {
    margin: 0;
    display: inline;
    & img {
      height: 60px;
      width: auto;
      margin-right: 20px;
    }
  }
  & a {
    text-decoration: none;
    color: var(--text);
    transition: 0.5s;
    &:hover {
      color: var(--highlight);
      /* text-shadow: 0 0 5px var(--text); */
    }
  }
  & ul {
    list-style-type: none;
    margin: 0 0 0 auto;
    padding: 0;
    & li {
      text-transform: uppercase;
      letter-spacing: 0.8px;
      display: inline-block;
      position: relative;
      & + li {
        margin-left: var(--outsidePadding);
      }
    }
  }
  & nav {
    display: none;
  }
  & div {
    position: fixed;
    height: 100vh;
    width: 250px;
    right: ${(props) => (props.menuOpen ? 0 : "-250px")};
    top: 0;
    bottom: 0;
    background-color: var(--white);
    z-index: 1000;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.125);
    transition: 0.5s;
    padding: var(--outsidePadding);
    & a {
      width: 100%;
      height: 100%;
      display: block;
    }
    & > ul {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      & li {
        display: block;
        margin: 0 0 4px 0;
        text-align: right;
      }
    }
  }
  @media (max-width: 1023px) {
    & .mobile {
      display: block;
    }
    & h1 span {
      display: none;
    }
    & > ul {
      display: none;
    }
    & > nav {
      margin-left: auto;
      display: block;
    }
  }
`;

export const HeaderShim = styled.div`
  height: var(--headerHeight);
`;

export const MenuDiv = styled.ul`
  position: ${(props) => (props.mobile ? "relative" : "absolute")};
  right: -10px;
  padding: 10px !important;
  display: flex;
  flex-direction: column;
  background-color: var(--white);
  box-shadow: ${(props) =>
    props.mobile ? "none" : "5px 5px 5px rgba(0, 0, 0, 0.125)"};
  & > li {
    position: relative;
    text-align: right;
    margin-left: 0 !important;
    white-space: nowrap;
    margin: 0 0 !important;
    & + li {
      margin-top: 10px !important;
    }
  }
`;
